import Vue from 'vue'
import VueRouter from 'vue-router'
import { auth } from '../firebase'

// Views
import Home from '../views/Home.vue'
import Checklist from '../views/Checklist.vue'
import ChecklistResults from '../views/ChecklistResults.vue'
import Booking from '../views/Booking.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import Consultation from '../views/Consultation.vue'
import Dashboard from '../views/Dashboard.vue'
import Login from '../views/Login.vue'

// Libraries
import goTo from 'vuetify/es5/services/goto'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/checklist',
    name: 'Checklist',
    component: Checklist
  },
  {
    path: '/results',
    name: 'ChecklistResults',
    component: ChecklistResults
  },
  {
    path: '/booking',
    name: 'Booking',
    component: Booking
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/consultation',
    name: 'Consultation',
    component: Consultation
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0

    if (to.hash) {
      scrollTo = to.hash
    } else if (savedPosition) {
      scrollTo = savedPosition.y
    }

    return goTo(scrollTo)
  }
})

// Route guards
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(path => path.meta.requiresAuth)
  const currentUser = auth.currentUser

  if (requiresAuth && !currentUser) next('/login')
  else if (currentUser && to.name == 'Login') next('/')
  else next()
})

export default router